import { createContentHook } from './createContentHook';
import type { ProductsContent } from '../types/ProductsContent';

export const useProductsContent = createContentHook<ProductsContent>('/Products');
